import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconNote } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type NotesButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

const Notes = ({ onClick, session }: NotesButtonProps) => {
  const {
    answered,
    callActions: { notes: isNotesOpened },
  } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <button
      type="button"
      title={t('components.activeCalls.btn.notes')}
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG src={IconNote} selected={isNotesOpened} />
    </button>
  );
};

export default Notes;
